// extracted by mini-css-extract-plugin
module.exports = {"d2xJ1":"J1_d2xJ1__EBu_V"};